import React from "react";
import { useNavigate} from "react-router-dom";
import kitchen from '../images/Stephens-Point-Kitchen-2.jpg'
import map from '../images/WebP/Area Map Screenshot.webp'

// import balcony from '../images/Balcony-Comp.jpg'
import "../style/Home.css"
// import Reviews from "./Reviews";






const Home = () => {

   const navigate = useNavigate();

    return(
        <div className='home'>
            
            <div className="top-intro-container">
              <div className="top-intro-box"></div>
              <div className="top-intro">
                <h1>Nebula Construction</h1>
                <br></br>
                <h2 className="home-intro-h2">General Contractor Serving Chesterfield VA, Richmond VA, Henrico VA, Powhatan VA</h2>
                <br></br>
                <h3 className="home-intro-h2">Residential Remodeling & Renovations</h3>
                <div className="top-intro-button-box">
                  <button className="button-5" onClick={() => navigate("/services")}>Our Services</button>
                  <button className="button-5" onClick={() => navigate("/contact")}>Request an Estimate</button>
                </div>
              </div>
            </div>

            
            <div className="home-about-box-wrapper">
              <div className="google-map-box">
              <img
                    src={map}
                    className="google-map"
                    alt="Google Map showing the service area of Nebula Construction around Richmond VA to include: Chesterfield VA, Henrico VA, Powhatan VA, Goochland VA."
                    title="Google Map showing the service area of Nebula Construction around Richmond VA to include: Chesterfield VA, Henrico VA, Powhatan VA, Goochland VA."
                    width="600"
                    height="450"
                    loading="lazy"
                  ></img>
              </div>
              <div className="home-about-box">
                <h2 className="about-h2">About Nebula Construction</h2>
                  <br></br>
                <p className="about-p">Your reliable partner for quality remodeling and renovations: Transforming Spaces, Building Dreams.</p> 
                  <br></br>
                <p className="about-p">Nebula Construction is a residential remodeling and renovation contractor serving the Greater Richmond, Virginia Metro Area. We specialize in kitchen and bathroom remodels, whole-home renovations, and home additions.
                </p> 
                  <br></br>
                <p className="about-p">Our team takes pride in delivering the highest quality throughout the construction process. 
                  We’re detail-oriented, ensuring you and our team are always in agreement on the project scope before construction begins. 
                  We maintain clear communication from start to finish so that your project stays on time, within budget, and aligned with your vision.
                </p> 
                  <br></br>
                  <p className="about-p">
                    {/* put today after contact us */}
                    Contact us today to schedule a free estimate and bring your next home transformation to life.
                  </p>
                  <br></br>
                <div className="button-box">
                  <button className="button-5" onClick={() => {navigate("/about"); window.scrollTo(0, 0);}}>Read More</button>
                </div>
              </div>
            </div>

            <div className="services-box-wrapper">

              <h2 className="section-header">Our Residential Services</h2>
            <div className="services-box">

              <div className="services-boxes">
              <div className="img-box">
                <img
                    src={kitchen}
                    alt="Kitchen Remodel with light blue cabinets, wood floors, stainless steel appliances, and marble countertops."
                    title="Kitchen Remodel with light blue cabinets, wood floors, stainless steel appliances, and marble countertops."
                    width="400"
                    height="250"
                    loading="lazy"
                  ></img>
              </div>
              <h3 className="services-title">Residential Remodeling & Renovations</h3>
      <p>
      Let us help you transform your living spaces into the home you’ve always envisioned. Here’s what we offer:
      </p>
      <ul>
        <li>Kitchen Remodeling & Renovations</li>
        <li>Bathroom Remodeling & Renovations</li>
        <li>Basement Remodeling & Renovations</li>
        <li>Home Office Remodeling & Renovations</li>
        <li>Whole Home Remodeling & Renovations</li>
        <li>Addition & Garage Construction</li>
      </ul>

                <div className="button-box">
                  <button className="button-5" onClick={() => {navigate("/residential-services"); window.scrollTo(0, 0);}}>Read More</button>
                </div>
                </div>

              {/* <div className="services-boxes">
                <div className="img-box">
                  <img  
                    src={balcony}
                    alt="Balcony"
                    width="250"
                    height="150"
                  ></img>
                </div>
                <h3 className="services-title">Commercial Services</h3>

                  <ul>
                    <li>Tenant Upfits, Remodeling, & Renovations</li>
                    <li>Office Upfits, Remodeling, & Renovations</li>
                    <li>Rental Property Remodeling & Renovations</li>
                    <li>Exterior Improvements</li>
                    <li>Warehouse Renovations</li>
                    <li>Facility Maintenance</li>
                    <li className="list-ghost">.</li>
                    <li className="list-ghost">.</li>
                  
                  </ul>

                <div className="button-box">
                  <button className="button-5" onClick={() => {navigate("/services"); window.scrollTo(0, 0);}}>Read More</button>
                </div>
              </div> */}

            </div>
            </div>
            
            {/* <Reviews /> */}
            
      </div>
    )

}

export default Home;
